/** @module React binding for the session module. */
import { useSyncExternalStore } from "react";

import { getSession, subscribe } from "@/lib/session";

export function useSession() {
  return useSyncExternalStore(subscribe, getSession, getSession);
}
